function processRequest(method, endpoint, payload, responseType) {
    var req = {
        method: method,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            //"X-XSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
    }

    if(payload && method == 'post') {
      payload._token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      req.body = JSON.stringify(payload)
    }

    return new Promise((resolve, reject) => {
        fetch(endpoint, req)
        .then(response => {
                if(response.status >= 400) {
                    throw('Request Failed with status ' + response.status)
                } else {
                    switch(responseType){
                        case 'json':
                            return response.json()
                        break;
                        case 'text':
                            return response.text()
                        break;
                        case 'none':
                            return ''
                        break;
                        default:
                            throw('Unknown Response Type')
                        break;
                    }
                }
            })
            .then(parsed => resolve(parsed))
            .catch(e => reject(e))
    })
}

const get = (endpoint, payload = {}, responseType = 'json') => {
    return processRequest('get', endpoint, payload, responseType)
}

const post = (endpoint, payload  = {}, responseType = 'json') => {
    return processRequest('post', endpoint, payload, responseType)
}

export default { get, post };
